import { StarWincon } from "../../../../src/data/format-guide/star-draft/StarWincon.tsx";
import * as React from 'react';
export default {
  StarWincon,
  React
};